export default "__VITE_ASSET__C3qi1m4A__"